// eslint-disable-next-line import/prefer-default-export
export class Counter {
  private counter: number;

  constructor(initial: number) {
    this.counter = initial;
  }

  get(): number {
    const result = this.counter;
    this.counter = result + 1;
    return result;
  }
}
